export const actions = {
  async nuxtServerInit({ state, dispatch }, { req }) {
    await dispatch("contentManagement/fetchLayoutContent", true)
  }
}
